import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDepartments(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('directory/departments', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteDepartment(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`directory/departments/${id}/delete`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
